// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e4Kb","top":"styles_top__1Qt3x"};